import { Button, Empty, Flex, Spin, Table } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { useNavigate, useParams } from 'react-router-dom'

import { useTreatmentServiceGetHivAnamnesisCaseEndpoint } from 'src/api/queries'
import { HivAnamnesisCaseResponse } from 'src/api/requests'
import { formatUtcDateTime } from 'src/libs'
import { useLocales } from 'src/locales'
import { paths } from 'src/paths'

import { HivAnamnesisStatusTag } from './HivAnamnesisStatusTag'

export const HivAnamnesisCaseTab = () => {
  const { t } = useLocales()
  const { id } = useParams()
  const navigate = useNavigate()

  const { data: hivAnamnesisCase, isLoading } =
    useTreatmentServiceGetHivAnamnesisCaseEndpoint(
      { personId: String(id) },
      [id],
      { enabled: !!id, retry: false }
    )

  if (isLoading) return <Spin />

  if (!hivAnamnesisCase?.id) {
    return <Empty description={t('hiv_anamnesis.no_case')} />
  }

  const columns: ColumnsType<HivAnamnesisCaseResponse> = [
    {
      key: 'anonymousIdentifier',
      title: t('hiv_anamnesis.anonymous_identifier'),
      render: (_, record) => record.form?.header?.anonymousIdentifier || '-'
    },
    {
      key: 'status',
      title: t('hiv_anamnesis.status_label'),
      render: (_, record) => <HivAnamnesisStatusTag status={record.status} />
    },
    {
      key: 'createdAt',
      title: t('hiv_anamnesis.created_at'),
      render: (_, record) => formatUtcDateTime(record.createdAt)
    },
    {
      key: 'completedAt',
      title: t('hiv_anamnesis.completed_at'),
      render: (_, record) => formatUtcDateTime(record.completedAt)
    },
    {
      key: 'actions',
      render: () => (
        <Button
          type="link"
          onClick={() => navigate(paths.patients.hivAnamnesis.root(String(id)))}
        >
          {t('common.details')}
        </Button>
      )
    }
  ]

  return (
    <Flex vertical gap={16}>
      <Table
        rowKey="id"
        scroll={{ x: 'max-content' }}
        columns={columns}
        dataSource={[hivAnamnesisCase]}
        pagination={false}
      />
    </Flex>
  )
}
